import { render, staticRenderFns } from "./BaseButtonMediumOrange.vue?vue&type=template&id=c5b40f94&scoped=true&"
import script from "./BaseButtonMediumOrange.vue?vue&type=script&lang=js&"
export * from "./BaseButtonMediumOrange.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonMediumOrange.vue?vue&type=style&index=0&id=c5b40f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b40f94",
  null
  
)

export default component.exports